import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router, ActivatedRouteSnapshot} from '@angular/router';
import { Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { EnvironmentProvider } from '../../core/browser-providers';
import { BackendService } from '../../core/backend.service';
import { Environment } from '../../../environments/enviroment.model';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { SearchInputComponent } from '../../shared-components/search-input/search-input.component';
import { Producto } from '../producto.model';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { SnackService } from '../../shared-services/snack.service';

enum ClienteEstadoLastLogin {
  ultimaSemana = 1,
  masUnaSemana = 2,
  masDosSemanas = 3
}

interface Filters {
  page: number;
  size: number;
  search?: string;
  sort?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-producto-list',
  templateUrl: './producto-list.component.html',
  styleUrls: ['./producto-list.component.scss']
})
@Injectable()
export class ProductoListComponent implements OnInit {

  private filters: Filters = {
    page: 0,
    size: 50,
    sort: 'created,desc'
  };

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  productosList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(Producto, Producto.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.roleFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Producto[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private dialogService: DialogService,
    private snackService: SnackService,
    private paginatorsLabels: MatPaginatorIntl,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
  ) {
  }

  async ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    await this.productosList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshRoleList();
  }

  refreshRoleList() {
    this.productosList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      page: 0,
      size: 50,
      sort: 'created,desc'
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshRoleList();
  }

  onSearch(searchText) {
    this.filters.search = 'nombre:' + searchText ;
    this.refreshRoleList();
  }

  clearSearch() {
    this.searchComponent.searchBox.value = '';
    this.refreshRoleList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  detallesProducto(id: number) {
    this.router.navigate(['/productos/detalles', id]);
  }

  onAddProducto() {
    this.router.navigate(['/productos/agregar']);
  }

  onAddProductoMassive() {
    this.router.navigate(['/productos/agregar-masivo']);
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onFiltersChanged(event) {
    this.refreshRoleList();
  }

  removeChip(event) {
    this.refreshRoleList();
  }

  redireccion(id: number) {
    this.router.navigate(['/productos/pedidos', id]);
  }

  async confirmEliminar(id: number) {
    this.dialogService.confirm('Eliminar Producto',
    '¿Está seguro que desea eliminar este producto?')
    .then( res => {
      if (res) {
        this.deleteProducto(res, id);
      }
    });
  }
  async deleteProducto(res, id) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Producto.newPath + 'eliminar/' + id);
        this.snackService.success('Producto eliminado correctamente');
        this.router.navigate(['/productos']);
        
        await this.productosList.subscribe(t => {
          this.isLoading = false;
          this.totalItems = t['totalItems'];
        });
    
        this.refreshRoleList();
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/producto-list/producto-list.component.ts